import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/site";

export const Seo = ({ title, description, path = "/", crumbs, jsonLd }) => {
  const url = SITE_URL ? `${SITE_URL}${path}` : null;
  const img = SITE_URL ? `${SITE_URL}/img/og.jpg` : null;
  const breadcrumb = crumbs && {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      ...(SITE_URL ? { item: `${SITE_URL}${c.path}` } : {}),
    })),
  };
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="District Gaslight" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {img && <meta name="twitter:image" content={img} />}
      {breadcrumb && <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
